import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";

interface ListProps {
  isScratched?: boolean;
  isInlineHandicapping?: boolean;
  hasSilk: boolean;
  useUpdatedVisual: boolean;
}

export const List = styled.ul<ListProps>`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  ${({ isInlineHandicapping, hasSilk, theme, useUpdatedVisual }) =>
    !isInlineHandicapping
      ? css`
          padding: ${theme.space["space-4"]} 0 0
            ${!hasSilk || useUpdatedVisual ? "54" : "80"}px;
        `
      : css`
          padding: ${`0 ${theme.space["space-4"]} ${theme.space["space-4"]} ${theme.space["space-4"]}`};
        `}
  ${({ isScratched }) =>
    isScratched &&
    css`
      opacity: 0.4;
    `}
  gap: ${({ theme }) => theme.space["space-3"]};

  &:is(:empty) {
    display: none;
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
    padding-top: ${({ theme }) => theme.space["space-2"]};
  }
`;
